import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { currentUser } from '../lib/session.ts'
import { SupportOutboxProvider } from '../lib/support-outbox.tsx'

/** Everything under this layout needs a session; without one the user goes to /login and back. */
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    const me = await currentUser(context.queryClient)
    if (!me) throw redirect({ to: '/login', search: { next: location.href } })
    return { me }
  },
  component: () => (
    <SupportOutboxProvider>
      <Outlet />
    </SupportOutboxProvider>
  ),
})
